import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

const initialState = {
  showSidebar: false,
  showIntercom: false,
  postponeNotificationDate: '',
  postponeInstallDate: '',
  fcmToken: '',
  showNotificationRequest: false,
  suspend: false,
  accountDeletion: false,
  postponeInformationBanner: '',
  accountDeletedPir: false,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  extraReducers(builder) {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    toggleSidebar: (state, actions) => {
      state.showSidebar = actions.payload
    },
    toggleIntercom: (state, actions) => {
      state.showIntercom = actions.payload
    },
    setPostponeNotificationDate: (state, actions) => {
      state.postponeNotificationDate = actions.payload
    },
    setPostponeInstallDate: (state, actions) => {
      state.postponeInstallDate = actions.payload
    },
    setFcmToken: (state, actions) => {
      state.fcmToken = actions.payload
    },
    setShowNotificationRequest: (state, actions) => {
      state.showNotificationRequest = actions.payload
    },
    setSuspend: (state, actions) => {
      state.suspend = actions.payload
    },
    setAccountDeletion: (state, actions) => {
      state.accountDeletion = actions.payload
    },
    setPosponeInformationBanner: (state, actions) => {
      state.postponeInformationBanner = actions.payload
    },
    setAccountDeletedPir: (state, actions) => {
      state.accountDeletedPir = actions.payload
    },
  },
})

export const {
  toggleSidebar,
  toggleIntercom,
  setPostponeNotificationDate,
  setPostponeInstallDate,
  setFcmToken,
  setShowNotificationRequest,
  setSuspend,
  setAccountDeletion,
  setPosponeInformationBanner,
  setAccountDeletedPir,
} = uiSlice.actions

export default uiSlice.reducer
